import { render, staticRenderFns } from "./fristStep.vue?vue&type=template&id=27d7bc96&scoped=true&"
import script from "./fristStep.vue?vue&type=script&lang=js&"
export * from "./fristStep.vue?vue&type=script&lang=js&"
import style0 from "./fristStep.vue?vue&type=style&index=0&id=27d7bc96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7bc96",
  null
  
)

export default component.exports